import { render } from "./DetailsIcon.vue?vue&type=template&id=6c71c204"
import script from "./DetailsIcon.vue?vue&type=script&lang=js"
export * from "./DetailsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__